import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import Swal from "sweetalert2";

const DelayInvoiceDialog = ({
  open,
  onClose,
  selectedInvoicesCount,
  onConfirm,
  isLoading = false,
}) => {
  const [postponedUntil, setPostponedUntil] = useState("");

  useEffect(() => {
    if (open) {
      // Set minimum date to tomorrow when dialog opens
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setPostponedUntil(tomorrow.toISOString().split('T')[0]);
    } else {
      setPostponedUntil("");
    }
  }, [open]);

  const handleConfirm = async () => {
    if (!postponedUntil) {
      Swal.fire({
        icon: "warning",
        title: "تحذير",
        text: "يرجى اختيار تاريخ التأجيل",
      });
      return;
    }

    const selectedDate = new Date(postponedUntil);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "يجب أن يكون تاريخ التأجيل بعد اليوم",
      });
      return;
    }

    // Call the parent's confirm handler with the selected date
    await onConfirm(postponedUntil);
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      dir="rtl"
      disableEscapeKeyDown={isLoading}
      disableBackdropClick={isLoading}
    >
      <Box 
        sx={{ 
          padding: 4, 
          backgroundColor: "white", 
          borderRadius: 2, 
          minWidth: 400,
          maxWidth: 500,
          margin: "auto",
          marginTop: "10vh"
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 3 }}>
          تأجيل الفواتير المحددة
        </Typography>
        
        <Typography variant="body2" sx={{ marginBottom: 2, color: "text.secondary" }}>
          عدد الفواتير المحددة: {selectedInvoicesCount}
        </Typography>
        
        <TextField
          variant="outlined"
          label="تاريخ التأجيل"
          type="date"
          fullWidth
          value={postponedUntil}
          onChange={(e) => setPostponedUntil(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0] // Tomorrow
          }}
          sx={{ marginBottom: 3 }}
          helperText="يجب أن يكون التاريخ بعد اليوم"
          disabled={isLoading}
        />
        
        <div style={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={isLoading}
            sx={{ marginLeft: 1 }}
          >
            إلغاء
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            disabled={!postponedUntil || isLoading}
          >
            {isLoading ? "جاري التأجيل..." : "تأكيد التأجيل"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DelayInvoiceDialog;
